import React from 'react';
import ExternalLink from 'components/Widgets/ExternalLink';

export default function OutlookLinkedBeforeText() {
  return (
    <>
      <p>
        <b>MS Office 365</b>
        {' '}
        account is not synchronized anymore.
      </p>
      <p>Sync your account by clicking the MS Office 365 button</p>
      <p>
        To completely disconnect your Microsoft Office 365 account please
        follow the steps described in the links:
        <ExternalLink
          variant="link"
          href="https://support.microsoft.com/en-us/topic/
          disconnect-your-linkedin-and-personal-accounts-a17d60af-1344-4008-9bde-f24fc278a412"
        >
          personal account
        </ExternalLink>
        {' '}
        or
        {' '}
        <ExternalLink
          variant="link"
          href="https://support.microsoft.com/en-us/office/
          disconnect-your-linkedin-and-work-or-school-accounts-b42fca09-31ea-4f6e-a4d2-b94df0a3166c"
        >
          work/school account
        </ExternalLink>

      </p>
    </>
  );
}
